export class BazaContentTypeCategoriesConfig {}

export function bazaContentTypeCategoriesDefaultConfig(): BazaContentTypeCategoriesConfig {
    return {};
}
